export default __webpack_public_path__ + "static/media/timeline_1.29185af7.svg";